import { render, staticRenderFns } from "./JOOM_V1.vue?vue&type=template&id=01f21fb4&scoped=true&"
import script from "./JOOM_V1.vue?vue&type=script&lang=js&"
export * from "./JOOM_V1.vue?vue&type=script&lang=js&"
import style0 from "./JOOM_V1.vue?vue&type=style&index=0&id=01f21fb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f21fb4",
  null
  
)

export default component.exports